import paymentList from "../../slices/payment/PaymentList";

const paymentReducer = {
    paymentList,
};

export default paymentReducer;
